import React, {useEffect, useState} from 'react';
import {Checkbox, ListItemIcon, ListItemText} from '@material-ui/core';
import RadioButtonChecked from '@material-ui/icons/RadioButtonChecked';
import RadioButtonUnchecked from '@material-ui/icons/RadioButtonUnchecked';
import AnswerListItem from '../AnswerListItem';
import ConvertToLatex from "../../../helper/ConvertToLatex";
import {getNewSelectedAnswers} from "../../../../helpers/QuestionHelper";
import withQuestionLogic from "../../../HOC/withQuestionLogic";
import withAnotherQuestion from "../../../HOC/withAnotherQuestion";
import ReactHtmlParser from 'react-html-parser';

const MultipleChoiceQuestion = (props) => {
    const {question, selectAnswer, markNextAble, selectedCode, studentAnswers, anotherQuestion, nextAnotherAble} = props;
    const [showAnotherTextField, setShowAnotherTextField] = useState(false);
    const [notAnotherQuestion, setNotAnotherQuestion] = useState(false);

    useEffect(() => {
        if (selectedCode.length > 0 && !showAnotherTextField) {
            markNextAble(true);
        }
    },[selectedCode]);

    return (
        <React.Fragment>
            {question.answers.map(answer => {
                return (
                    <AnswerListItem
                        disableRipple
                        button
                        key={answer.answerCode}
                        selected={(selectedCode.length > 0 && selectedCode[0] === answer.answerCode) || nextAnotherAble}
                        onClick={() => {
                            studentAnswers.forEach((studentAnswer) => {
                                if (answer.answerCode === `${question.questionCode}_another` && studentAnswer.answerCode === `${question.questionCode}_another`) {
                                    setShowAnotherTextField(true);
                                } else {
                                    setShowAnotherTextField(false);
                                }
                            });
                            if (answer.answerCode.includes('another') && !nextAnotherAble) {
                                markNextAble(false);
                            } else {
                                setNotAnotherQuestion(true);
                                markNextAble(true);
                            }
                            selectAnswer(question.questionCode, getNewSelectedAnswers(question, answer.answerCode, studentAnswers, ""));
                        }}
                    >
                        <ListItemIcon style={{minWidth: 10}}>
                            <Checkbox
                                icon={<RadioButtonUnchecked style={{width: 15}}/>}
                                checkedIcon={<RadioButtonChecked style={{width: 15}}/>}
                                edge="start"
                                checked={selectedCode.length > 0 && selectedCode[0] === answer.answerCode}
                                tabIndex={-1}
                            />
                        </ListItemIcon>
                        <div className="question-content">
                            {answer.content.search("latex") === -1 ?
                                <ListItemText>
                                    {ReactHtmlParser(answer.content)}
                                </ListItemText> :
                                <ListItemText>
                                    <ConvertToLatex textInput={answer.content}/>
                                </ListItemText>
                            }
                        </div>
                    </AnswerListItem>
                );
            })}
            {question.hasOptionalAnswer && (showAnotherTextField || (nextAnotherAble && !notAnotherQuestion)) ? anotherQuestion : ""}
        </React.Fragment>
    );
};

export default withQuestionLogic(withAnotherQuestion(MultipleChoiceQuestion));
